import { EmployeeDTO } from '@iota/iota-management-portal-v4-client';
import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { createReducer, createSelector, on } from '@ngrx/store';
import moment from 'moment';
import { LoadEmployeesSuccess } from '../actions/employee.actions';
import { AppState } from '../store';

export type EmployeeState = EntityState<EmployeeDTO>;

function selectEmployeeId(a: EmployeeDTO): string {
    return a.employeeId;
}

function sortEmployees(a: EmployeeDTO, b: EmployeeDTO): number {
    return moment(b.creationDateTime).toDate().getTime() - moment(a.creationDateTime).toDate().getTime();
}

export const employeeAdapter: EntityAdapter<EmployeeDTO> = createEntityAdapter<EmployeeDTO>({
    selectId: selectEmployeeId,
    sortComparer: sortEmployees
});

export const initialState: EmployeeState = employeeAdapter.getInitialState();

export const employeeReducer = createReducer(
    initialState,

    on(LoadEmployeesSuccess, (state, { employees }) => employeeAdapter.upsertMany(Array.isArray(employees) ? employees : [], state))
);

const { selectAll } = employeeAdapter.getSelectors();

export const employeeState = (state: AppState) => state.employeeState;
export const employees = createSelector(employeeState, selectAll);

export const employeesByCompany = (companyId: string) =>
    createSelector(employees, (employees) => employees.filter((elem) => elem.companyId === companyId));
